import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { CtaBand } from "../components/home/CtaBand";
import { TestimonialCard, TestimonialInvite } from "../components/home/Testimonials";
import { Eyebrow, Reveal } from "../components/motion";
import { TESTIMONIALS, AVIS_CAPTURES } from "../data/content";

export default function Avis() {
  const navigate = useNavigate();
  return (
    <main data-testid="page-avis">
      <Seo
        title="Avis clients — Accompagnement investissement immobilier atypique | Demoiselle Atypique"
        description="Les retours de nos clients sur la création de suites romantiques, hébergements familiaux à thème et logements atypiques rentables. Des témoignages et résultats réels, jamais inventés."
      />

      <section className="px-6 pt-40 sm:px-10 lg:px-16">
        <div className="mx-auto max-w-[1500px]">
          <Eyebrow>Avis clients</Eyebrow>
          <h1 className="mt-6 max-w-4xl font-serif text-5xl leading-[1.06] text-cream sm:text-6xl lg:text-7xl">
            Ils avaient une idée. Ils en ont fait un projet.
          </h1>
          <p className="mt-8 max-w-2xl leading-relaxed text-white/55">
            Chaque accompagnement est une collaboration. Les témoignages, résultats et chiffres publiés sur cette page
            sont réels et publiés avec l'accord de nos clients : nous préférons en montrer peu, mais être
            irréprochables.
          </p>
        </div>
      </section>

      <section className="px-6 py-16 sm:px-10 lg:px-16 lg:py-24">
        <div className="mx-auto max-w-[1500px]">
          <div className="grid gap-6 md:grid-cols-3">
            {TESTIMONIALS.map((t, i) => (
              <Reveal key={t.prenom} delay={i * 0.08} className="h-full">
                <TestimonialCard t={t} />
              </Reveal>
            ))}
            <Reveal delay={0.16} className="h-full">
              <TestimonialInvite />
            </Reveal>
          </div>

          {AVIS_CAPTURES.length > 0 && (
            <Reveal delay={0.12}>
              <p className="mt-16 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
                Captures réelles de nos annonces & avis voyageurs
              </p>
              <div className="mt-6 grid gap-6 md:grid-cols-3" data-testid="avis-captures">
                {AVIS_CAPTURES.map((c, i) => (
                  <img key={i} src={c.image} alt={c.alt} className="aspect-[16/10] w-full border border-white/10 object-cover" loading="lazy" />
                ))}
              </div>
            </Reveal>
          )}

          <Reveal delay={0.14}>
            <div className="mt-16 grid items-center gap-10 border border-white/10 bg-[#1D1327] p-8 lg:grid-cols-2 lg:p-12">
              <img
                src="/clients/couple-notaire.jpg"
                alt="Nos clients souriants devant le notaire, clés du bien en main, au moment de l'achat"
                className="aspect-[4/3] w-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">Jour J</p>
                <p className="mt-6 font-serif text-3xl leading-snug text-cream lg:text-4xl">
                  Nos clients, devant chez le notaire, clés en main.
                </p>
                <p className="mt-6 leading-relaxed text-white/55">
                  Derrière chaque logement atypique, il y a un achat préparé, négocié et sécurisé étape par étape avec
                  notre équipe.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="border-t border-white/10 bg-[#1D1327] py-20 text-center">
        <div className="mx-auto max-w-3xl px-6">
          <Reveal>
            <h2 className="font-serif text-4xl text-cream sm:text-5xl">Et si le prochain projet était le vôtre ?</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <button onClick={() => navigate("/rendez-vous")} data-testid="avis-cta" className="btn-primary mt-10">
              Parler de mon projet <ArrowRight className="h-4 w-4" />
            </button>
          </Reveal>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
